export class Search {
    searchId: string
    companyId: string
    limit: number
    createdAt: string | Date
    updatedAt: string | Date
    startedAt?: string | Date
    finishedAt?: string | Date
    status: number
    cityId: string
    categoryId: string
    notes?: string
    lastBusinessAddedCreationDate?: string | Date
    total?: number
    totalPhone?: number
    totalWA?: number
    totalWAB?: number
    totalEmail?: number
    category?: any
    city?: any
}
